import { Component, Input, OnInit } from '@angular/core';
import { menu } from 'src/app/models/menu';
import { rootModel } from 'src/app/models/rootModel';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit {


  @Input() menu:menu;
  @Input() rootModel:rootModel;

 

  constructor() { }

  ngOnInit(): void {    
    

    
  }

  
  strbosluk(str:string)
  {
    var i:number; 
    var bosluk = str.split(' ').length;
    for(i = bosluk ;i>=1;i--) {
      str = str.replace(' ','-');
     }        
    return str;
  }

}
